import { Icon, IconNames } from "../Icons/LucideIcons";
import { StyledActionButton } from "./__styles__/ActionButton";
import { type BaseButtonProps } from "./__styles__/BaseButton";

export type ActionButtonProps = Omit<
  BaseButtonProps,
  "children" | "isPending"
> & {
  icon?: IconNames;
  variant?: ActionButtonVariant;
  size?: "xs" | "small" | "medium";
};

type ActionButtonVariant = "default" | "inverted";

export function ActionButton({
  "aria-label": ariaLabel = "more actions",
  icon = "ellipsis",
  variant = "default",
  size = "small",
  ...props
}: ActionButtonProps) {
  const contentColor =
    variant === "inverted" ? "contentPrimaryInverted" : "contentSecondary";

  const hoveredColor =
    variant === "inverted" ? "contentPrimaryInverted" : "contentPrimary";

  const iconSize = size === "xs" ? 12 : size === "small" ? 16 : 24;
  return (
    <StyledActionButton
      {...props}
      aria-label={ariaLabel}
      variant={variant}
      size={size}
    >
      {({ isHovered }) => {
        return (
          <Icon
            aria-hidden={true}
            iconName={icon}
            size={iconSize}
            color={isHovered ? hoveredColor : contentColor}
          />
        );
      }}
    </StyledActionButton>
  );
}
